export const cibScala = ["32 32","<path d='M6.12 32c6.047 0 18.411-2.021 19.76-4v-7.641c-1.276 1.88-13.714 3.885-19.76 3.885zM6.12 21.818c6.047 0 18.411-2.021 19.76-4v-7.635c-1.276 1.875-13.714 3.88-19.76 3.88zM6.12 11.641c6.047 0 18.411-2.021 19.76-4v-7.641c-1.276 1.875-13.714 3.88-19.76 3.88z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-scala.js
// module id = null
// module chunks = 